import logo1 from "../../assets/company-logos/logo1.png"
import logo2 from "../../assets/company-logos/logo2.png"
import logo3 from "../../assets/company-logos/logo3.png"
import logo4 from "../../assets/company-logos/logo4.png"
import logo5 from "../../assets/company-logos/logo5.png"
import logo6 from "../../assets/company-logos/logo6.png"
import logo7 from "../../assets/company-logos/logo7.png"

export default function Partner() {
  return (
    <section className="py-8 bg-gray-50">
      <div className="container mx-auto">
        <div className="partner-carousel">
          <div className="partner-track">
            {
              [logo1, logo2, logo3, logo4, logo5,logo6, logo7, logo1, logo2, logo3].map((logo, index) => (
                <div className="partner-logo">
                  <img src={logo} alt="company-logo" className="w-24 h-12 text-blue-600" />
                  {/*<svg*/}
                  {/*  className="w-24 h-12 text-blue-600"*/}
                  {/*  viewBox="0 0 200 60"*/}
                  {/*  fill="currentColor"*/}
                  {/*>*/}
                  {/*  <path d="M30,15 L50,15 L50,45 L30,45 Z M10,15 L25,15 L25,45 L10,45 Z M55,15 L70,15 L70,45 L55,45 Z M75,15 L90,15 L90,45 L75,45 Z"></path>*/}
                  {/*</svg>*/}
                </div>
              ))
            }
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <circle*/}
            {/*      cx="30"*/}
            {/*      cy="30"*/}
            {/*      r="20"*/}
            {/*    ></circle>*/}
            {/*    <circle*/}
            {/*      cx="80"*/}
            {/*      cy="30"*/}
            {/*      r="20"*/}
            {/*    ></circle>*/}
            {/*    <circle*/}
            {/*      cx="130"*/}
            {/*      cy="30"*/}
            {/*      r="20"*/}
            {/*    ></circle>*/}
            {/*  </svg>*/}
            {/*</div>*/}
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <path d="M10,10 L90,10 L90,50 L10,50 Z"></path>*/}
            {/*  </svg>*/}
            {/*</div>*/}
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <path d="M20,10 L50,50 L80,10 Z"></path>*/}
            {/*  </svg>*/}
            {/*</div>*/}
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <rect*/}
            {/*      x="10"*/}
            {/*      y="10"*/}
            {/*      width="80"*/}
            {/*      height="40"*/}
            {/*      rx="20"*/}
            {/*    ></rect>*/}
            {/*  </svg>*/}
            {/*</div>*/}

            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <path d="M30,15 L50,15 L50,45 L30,45 Z M10,15 L25,15 L25,45 L10,45 Z M55,15 L70,15 L70,45 L55,45 Z M75,15 L90,15 L90,45 L75,45 Z"></path>*/}
            {/*  </svg>*/}
            {/*</div>*/}
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <circle*/}
            {/*      cx="30"*/}
            {/*      cy="30"*/}
            {/*      r="20"*/}
            {/*    ></circle>*/}
            {/*    <circle*/}
            {/*      cx="80"*/}
            {/*      cy="30"*/}
            {/*      r="20"*/}
            {/*    ></circle>*/}
            {/*    <circle*/}
            {/*      cx="130"*/}
            {/*      cy="30"*/}
            {/*      r="20"*/}
            {/*    ></circle>*/}
            {/*  </svg>*/}
            {/*</div>*/}
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <path d="M10,10 L90,10 L90,50 L10,50 Z"></path>*/}
            {/*  </svg>*/}
            {/*</div>*/}
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <path d="M20,10 L50,50 L80,10 Z"></path>*/}
            {/*  </svg>*/}
            {/*</div>*/}
            {/*<div className="partner-logo">*/}
            {/*  <svg*/}
            {/*    className="w-24 h-12 text-blue-600"*/}
            {/*    viewBox="0 0 200 60"*/}
            {/*    fill="currentColor"*/}
            {/*  >*/}
            {/*    <rect*/}
            {/*      x="10"*/}
            {/*      y="10"*/}
            {/*      width="80"*/}
            {/*      height="40"*/}
            {/*      rx="20"*/}
            {/*    ></rect>*/}
            {/*  </svg>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    </section>
  );
}
